import React, { useState, useEffect } from "react";
import { Link, ResponsiveImage, LazyLoadImages } from "@quintype/components";
import { ResponsiveBannerImage } from "../../utils/responsive-image";
const MagazineSideCol = ({ data }) => {
  let magazine = data[1];

  if (magazine.length === 0) {
    return (
      <div className="mt-5 px-5 py-4">
        <div className="h-[350px] w-full animate-pulse bg-gray-300"></div>
      </div>
    );
  }

  return (
    <div className="mt-5 flex  justify-center bg-[#f1f0ef] px-5  py-4 dark:bg-zinc-800">
      <div className="flex w-full flex-col">
        <div className="ml-[26px]">
          <h2 className="text-2xl font-bold text-[#ca4242] ">Magazine</h2>
          <hr className="mt-1 h-[4px] w-[20%] border-none  bg-primary" />
        </div>
        <figure className="mt-3 flex justify-center">
          <Link href={`/issue/${magazine["slug"]}`}>
            <div className="w-[208px]">
              <LazyLoadImages>
                {/* <ResponsiveImage
                  slug={magazine.metadata["cover-image"]["cover-image-s3-key"]}
                  aspect-ratio={[1, 1]}
                  defaultWidth={268}
                  imgParams={{ auto: ["format", "compress"], q: 75, fm: "webp" }}
                  alt="image"
                /> */}

                <ResponsiveBannerImage
                  slug={magazine.metadata["cover-image"]["cover-image-s3-key"]}
                  alt="image"
                  quality="25"
                  width="500"
                />
              </LazyLoadImages>
            </div>
          </Link>
        </figure>
      </div>
    </div>
  );
};

export default MagazineSideCol;
